import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function QuickReading() {
    useEffect(() => {
        document.title = 'КьюАй - Скорочтение';
    }, [])

    return <>
        <div>
            В центре детского развития КьюАй мы предлагаем уникальный курс Скорочтение - эффективный метод,
            направленный на развитие скорости чтения про себя и вслух. Наша программа строится на принципах,
            которые помогут ребенку не только читать быстрее, но и понимать прочитанное. Учение в нашей школе -
            это интересный и игровой процесс, который ребенок будет ждать с нетерпением. Вы получите поддержку
            экспертных педагогов и доступ к интерактивным материалам и тестам, что позволит повысить
            эффективность обучения. Ваш ребенок будет восхищен своими успехами и вам не придется беспокоиться о
            его заинтересованности в учебе.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Развитие умения читать ритмично;</li>
                    <li>Улучшение понимания и запоминания прочитанного;</li>
                    <li>Укрепление навыка улавливания основной мысли;</li>
                    <li>Формирование умения обрабатывать большие объемы информации за короткий промежуток времени;</li>
                    <li>Повышение уровня успеваемость;</li>
                    <li>Культивирование заинтересованности и любви к книгам;</li>
                    <li>Улучшение речи;</li>
                    <li>Расширение кругозора.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-sch"></div>
            </div>
        </div>
        <div>
            Наши педагоги разработали уникальную методику, которая позволяет детям увеличить скорость чтения в
            1,5-2 раза, а также повысить качество понимания. Курсы не только развивают навык чтения, но и другие
            способности, такие как память, концентрацию внимания и интеллектуальную выносливость. Ребенок сможет
            воспринимать в 2-3 раза больше информации, сократится время на выполнение домашних заданий, а также
            исчезнут сложности с пересказом и пониманием текстовых упражнений.
        </div>
        <div>
            Родители, предлагаем вам воспользоваться уникальным шансом для ваших деток и начать обучение в КьюАй
            на курсе Скорочтение. Вы можете поспособствовать развитию у ваших детей важнейших навыков, таких как
            скорость и эффективность чтения, и повысить их успеваемость в учебе и уверенность в себе. Не
            упустите этот шанс, запишитесь на курс прямо сейчас!
        </div>
    </>
}